import ConversationRecord from "models/view-models/conversations/conversation-record";
import React, { useEffect, useRef, useState } from "react";
import { PAST_CONVO_GROUP_BASE_CLASS_NAME } from "./chat-past-conversations-group";
import useOutsideClick from "utilities/hooks/use-outside-click";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface ChatTitleInputProps {
    conversation: Pick<ConversationRecord, "id" | "title">;
    onSubmit: (title: string) => void;
    onCancel: () => void;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const ChatTitleInput: React.FC<ChatTitleInputProps> = ({
    conversation,
    onSubmit,
    onCancel,
}) => {
    const [newTitle, setNewTitle] = useState<string>(conversation.title ?? "");
    const inputRef = useRef<HTMLInputElement | null>(null);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onSubmit(newTitle.trim());
        } else if (e.key === "Escape") {
            e.stopPropagation();
            onCancel();
        }
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, []);

    useOutsideClick(inputRef, onCancel, "mousedown");

    return (
        <input
            ref={inputRef}
            type="text"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            onKeyDown={handleKeyDown}
            className={`${PAST_CONVO_GROUP_BASE_CLASS_NAME}__edit-input`}
            autoFocus
        />
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default ChatTitleInput;

// #endregion Exports
